export default function getId(row: any, isArbitrate?: boolean): number {
    let id = row.id || row.Id || row.ID
    if (isArbitrate) {
        id = row.objId || row.ObjId
    }
    if (!id) throw new Error('Missing ID in row')
    return Number(id)
}

export function getCaseInsensitive(obj: any, key: string) {
    const foundKey = Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
    return foundKey ? obj[foundKey] : undefined;
}
